import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Button.module.scss'

const Button = ({ variant = 'primary', loading = false, disabled = false, className, children, ...props }) => (
  <button
    type='button'
    {...props}
    disabled={disabled || loading}
    className={classNames({ 'btn btn-primary text-white': variant === 'primary' }, classes[variant], className)}
  >
    {loading && <i className='fa fa-spinner fa-spin mr-2' aria-hidden='true' />}
    {children}
  </button>
)

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'outline']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Button
